import React from 'react';
import { Link } from 'react-router-dom';
import { Permissions } from '@upstart/harmony/lib/constants';
import withDealerPermission from './dealerPermission';

function AddButton() {
  return (
    <Link
      className="btn btn-primary btn-large new-btn-space"
      to={{ pathname: '/dealer/' }}
    >
      Add New
    </Link>
  );
}

export default withDealerPermission(Permissions.CREATE)(AddButton);
